// encryptedStorage.js

const ENCRYPTION_KEY = 'W6PQxMnCwDPKH1ThQnEgNE1rRBxowLWHCnvBmE0UDx2BnsrfJKJRvi0vF';

// Simple XOR encryption (same as before)
function xorEncrypt(text, key) {
	let result = '';
	for (let i = 0; i < text.length; i++) {
		result += String.fromCharCode(text.charCodeAt(i) ^ key.charCodeAt(i % key.length));
	}
	return result;
}

export const encryptedStorage = {
	getItem: (key) => {
		try {
			const base64 = localStorage.getItem(key);
			if (!base64) return Promise.resolve(null);

			// Decode base64 to Uint8Array → then to string
			const binaryString = atob(base64);
			const byteArray = Uint8Array.from(binaryString, (c) => c.charCodeAt(0));
			const decrypted = xorEncrypt(new TextDecoder().decode(byteArray), ENCRYPTION_KEY);

			return Promise.resolve(decrypted);
		} catch (err) {
			console.warn('[persist-storage] Failed to de-c:', err);
			return Promise.resolve(null);
		}
	},

	setItem: (key, value) => {
		try {
			const encrypted = xorEncrypt(value, ENCRYPTION_KEY);

			// Convert encrypted string to binary-safe base64
			const utf8Bytes = new TextEncoder().encode(encrypted); // → Uint8Array
			const base64 = btoa(String.fromCharCode(...utf8Bytes)); // → base64 string

			localStorage.setItem(key, base64);
			return Promise.resolve();
		} catch (err) {
			console.warn('[persist-storage] Failed to en:', err);
			return Promise.resolve();
		}
	},

	removeItem: (key) => {
		localStorage.removeItem(key);
		return Promise.resolve();
	},
};
